var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "vue-countdown-component",
        { theme2: _vm.theme !== 1 },
        { ie: _vm.isIE }
      ]
    },
    [
      _vm._l(_vm.timeArray, function(item, index) {
        return [
          _c("div", { key: index, class: ["time-box"] }, [
            _c("div", { staticClass: "base" }, [
              _vm._v(_vm._s(item)),
              _c("div", { staticClass: "base-b" }, [
                _vm._v(_vm._s(_vm.timeArrayT[index]))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: ["face", { anime: _vm.isAnimate[index] }],
                on: {
                  animationend: function($event) {
                    return _vm.onAnimateEnd(index)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.timeArrayT[index]))]
            ),
            _vm._v(" "),
            _c("div", { class: ["back", { anime: _vm.isAnimate[index] }] }, [
              _vm._v(_vm._s(item))
            ])
          ]),
          _vm._v(" "),
          _vm.isTimeUnitShow(index)
            ? _c("div", { key: "unit-" + index, staticClass: "time-unit" }, [
                _vm._v("\n      " + _vm._s(_vm.setTimeUnit(index)) + "\n    ")
              ])
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6413583b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6413583b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/flip/flip.vue
// module id = null
// module chunks = 